import { createReducer } from "@reduxjs/toolkit";
import { resetUpdateTeacherTeaching, updateTeacherTeaching } from "./update-teacher-teaching";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const updateTeacherTeachingReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(updateTeacherTeaching.fulfilled, state => {
    return { ...state, processing: "success" };
  });
  builder.addCase(updateTeacherTeaching.pending, state => {
    return { ...state, processing: "pending" };
  });
  builder.addCase(updateTeacherTeaching.rejected, state => {
    return { ...state, processing: "failed" };
  });
  builder.addCase(resetUpdateTeacherTeaching, () => {
    return initialState;
  });
});
